import React from 'react'
import classNames from 'classnames'

import { StateProvider, getHTML, getRichText } from '../../core'
import MediaWithContent from '../MediaWithContent'

import './banner.scss'

class BannerSection extends React.Component {
  render() {
    const data = this.props.data || {}
    const context = this.props.context || {}

    const { isFixed } = this.props

    if (
      !data
    ) return null

    const { 
      theme,
      headlineContent,
      sublineContent,
    } = data

    const bannerClass = classNames(
      'banner',
      theme && `theme-${theme} `,
      isFixed && 'is-fixed'
    )

    return (
      <section styleName={`${bannerClass}`}>
        <div styleName='banner-inner'>
          {data.static}
          {!data.static && headlineContent && (
            <div styleName='headline'>{getRichText(headlineContent)}</div>
          )}
          {!data.static && data.staticHeadline && (
            <div styleName='headline'>{data.staticHeadline}</div>
          )}
          {!data.static && sublineContent && (
            <div styleName='subline'>{getRichText(sublineContent)}</div>
          )}
          {!data.static && data.staticSubline && (
            <div styleName='subline'>{data.staticSubline}</div>
          )}
        </div>
      </section>
    )
  }
}

export default BannerSection